import SectionHeading from '@/pages/home/components/SectionHeading';
import { entranceCards, coverStrip } from '@/mocks/home';

const accentStyles: Record<string, { bubble: string; badge: string }> = {
  primary: {
    bubble: 'bg-primary-100 text-primary-700',
    badge: 'bg-primary-100 text-primary-800',
  },
  accent: {
    bubble: 'bg-accent-100 text-accent-700',
    badge: 'bg-accent-100 text-accent-800',
  },
  secondary: {
    bubble: 'bg-secondary-100 text-secondary-700',
    badge: 'bg-secondary-100 text-secondary-800',
  },
};

export default function EntranceIndex() {
  return (
    <section id="entrance" className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-50">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <SectionHeading
          index="01"
          eyebrow="Entrance Index"
          title="入口索引 · 一处找全"
          desc="把官网入口、最新地址、APP 下载与备用线路按用途归类。第一次来先看这里，基本就能定位到你要的入口。"
        />
        <a
          href="#address"
          className="inline-flex items-center gap-2 font-label text-sm text-primary-700 hover:text-primary-800 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看完整地址列表
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </a>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {entranceCards.map((card) => {
          const style = accentStyles[card.accent] ?? accentStyles.primary;
          return (
            <article
              key={card.id}
              className="group relative flex flex-col p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center justify-between mb-6">
                <span className={`w-12 h-12 flex items-center justify-center rounded-md text-2xl ${style.bubble}`}>
                  <i className={card.icon} aria-hidden="true"></i>
                </span>
                <span className="font-heading font-black text-2xl text-background-400">
                  {card.no}
                </span>
              </div>
              <span className={`self-start font-label text-[11px] px-2 py-1 rounded-full ${style.badge}`}>
                {card.badge}
              </span>
              <h3 className="mt-3 font-heading font-bold text-lg text-foreground-950">
                {card.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">
                {card.desc}
              </p>
              <a
                href={card.href}
                className="mt-5 inline-flex items-center gap-1.5 font-label text-sm text-foreground-800 group-hover:text-primary-700 transition-colors cursor-pointer"
              >
                {card.id === 'app' ? '前往下载' : '立即进入'}
                <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
              </a>
            </article>
          );
        })}
      </div>

      <div className="mt-12">
        <div className="flex items-center gap-3 mb-5">
          <span className="font-heading font-bold text-sm text-foreground-950">
            封面速览 · 影视观看
          </span>
          <span className="flex-1 h-px bg-background-200" />
          <span className="font-label text-xs text-foreground-500">封面驱动更直观</span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {coverStrip.map((cover) => (
            <article key={cover.id} className="group relative rounded-lg overflow-hidden border border-background-200">
              <div className="w-full aspect-[4/5] md:aspect-[3/4] bg-background-200 overflow-hidden">
                <img
                  src={cover.image}
                  alt={`${cover.title} ${cover.sub}`}
                  title={`${cover.title} ${cover.sub} 青苹果影院`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-foreground-950/80 to-transparent">
                <span className="font-label text-[11px] text-accent-300">{cover.sub}</span>
                <h3 className="font-heading font-bold text-base text-background-50">
                  {cover.title}
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}